// Words inside the shared calculator form card on /hi/pitra-dosha/ and the
// controls of its answer: submit, the check's errors, and the answer's link and
// button. Hindi controls are Devanagari Hindi, like the card's labels in
// BirthDetailsForm.i18n.ts (owner decision 2026-10-28, replacing the
// 2026-10-08 Hinglish rule; tests/hindi-register.test.ts guards this file).
// The section heading and the answer's text are page copy in their components.
export const PITRA_CHECK_COPY = {
  // The English check's Hindi submit and errors (PitraDoshCheck.tsx).
  submit: "पितृ दोष जाँचें",
  needsTime:
    "जन्म समय डालें। पितृ दोष नवम भाव और नवमेश से पढ़ा जाता है, जिसके लिए सही जन्म समय चाहिए।",
  unavailable: "गणना नहीं हो पाई — कृपया दोबारा कोशिश करें।",
  upay: "उपाय पढ़ें",
  checkAnother: "दूसरी कुंडली जाँचें",
} as const;

/**
 * The check's form props, shared by the server-rendered shell (PitraCheckHiLazy),
 * the island's BirthDetailsForm and BirthToolFormShell.parity.test.tsx, as the
 * Hindi antardasha check's card does: no name field (the answer does not use
 * one) and no form heading (the section's H2 names the card; BirthDetailsForm
 * keys its input ids on the heading). The birth time is required: the 9th
 * house and its lord come from the Lagna, and the site names no dosha without
 * a birth time.
 */
export const PITRA_CHECK_FORM = {
  language: "hi",
  submitLabel: PITRA_CHECK_COPY.submit,
  collectName: false,
  requireBirthTime: true,
} as const;

/**
 * One box for every state of the check's slot (the rashi check's frame,
 * RASHI_CHECK_FRAME): the shell, the loading shell, the live form and the answer
 * each fill the slot's reserved height, and the submit sits at the foot of the
 * box in every state with one 48 px height. So neither the island arriving after
 * a tap nor an alert after a slow engine reply moves anything in the slot.
 */
export const PITRA_CHECK_FRAME =
  "mx-auto flex w-full max-w-md flex-1 flex-col [&>form]:flex [&>form]:flex-1 [&>form]:flex-col [&>form>:last-child]:mt-auto [&>form>:last-child]:min-h-12";

/** The real form's input ids (no heading prop, so BirthDetailsForm's "-default" ids). */
export const PITRA_CHECK_FIELD_IDS = {
  date: "birthDate-default",
  time: "birthTime-default",
  place: "birthPlace-default",
} as const;

/** free_tool_started and calculator_used placement for the Hindi page check. */
export const PITRA_CHECK_PLACEMENT = "hi_pitra_page_check";

/** The page's upay section, which the answer links (a Hindi page links Hindi pages). */
export const PITRA_UPAY_ANCHOR = "pitra-upay";
